module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white@3x-dde9838a2d9ef4963250cdfcee574512.png";